/** Reads and JSON-parses a localStorage value — `undefined` on absence, corrupt data, or an unavailable store (private browsing, quota). */
export function readLocalStorageJSON<T>(key: string): T | undefined {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : undefined;
  } catch {
    return undefined;
  }
}

/** JSON-serializes and writes a localStorage value — silently no-ops on an unavailable store. */
export function writeLocalStorageJSON<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // localStorage may be unavailable (private browsing, quota) — non-critical, skip silently
  }
}
